import axios from 'axios';
import { API } from '../../contexts/AuthContext';

// Token do participante (publico) guardado por slug — separado do mkt_token do admin.
const tokenKey = (slug) => `torc_token_${slug}`;
export const getToken = (slug) => localStorage.getItem(tokenKey(slug));
export const setToken = (slug, t) => localStorage.setItem(tokenKey(slug), t);
export const clearToken = (slug) => localStorage.removeItem(tokenKey(slug));

const auth = (slug) => {
  const t = getToken(slug);
  return t ? { headers: { Authorization: `Bearer ${t}` } } : {};
};

const P = `${API}/publico/torcida`;

// URL publica do PDF do regulamento (servido pelo backend, atualizavel no admin)
export const REGULAMENTO_URL = `${P}/regulamento`;

export const torcidaApi = {
  // QR unico — o backend detecta se e funcionario (rh) ou cliente (clientecad)
  identificar: (slug, cpf, autoriza) =>
    axios.post(`${P}/identificar`, { slug, cpf, autoriza_exibicao_publica: autoriza }),
  jogos: (slug) => axios.get(`${P}/jogos`, auth(slug)),
  palpitar: (slug, body) => axios.post(`${P}/palpitar`, body, auth(slug)),
  minhaPosicao: (slug) => axios.get(`${P}/minha-posicao`, auth(slug)),
  preferencia: (slug, autoriza) => axios.put(`${P}/preferencia-exibicao`, { autoriza }, auth(slug)),
  ranking: (slug, tipo) => axios.get(`${P}/ranking/${slug}${tipo ? `?tipo=${tipo}` : ''}`),
  rankingGlobalFunc: () => axios.get(`${P}/ranking-funcionarios-global`),
  tv: (slug) => axios.get(`${P}/tv/${slug}`),
};

// Formata CPF enquanto digita: 123.456.789-00
export function mascararCpfInput(valor) {
  const d = String(valor).replace(/\D/g, '').slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
}
